/**
 * External Dependencies
 */

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const $ = jQuery;

import Splide from '@splidejs/splide';
import Plyr from 'plyr';

$(function () {

  /* Social shares */
  function wiSocialShares() {
    $(document).on('click', '.facebook-share-js', function (event) {
      event.preventDefault();
      var link = $(this).attr('href');
      FB.ui({
        method: 'share',
        href: link,
      }, function (response) {});

    });

    $(document).on('click', '.twitter-share-js', function (event) {
      event.preventDefault();
      var url = $(this).attr('href'),
        width = 575,
        height = 400,
        left = ($(window).width() - width) / 2,
        top = ($(window).height() - height) / 2,
        opts = 'status=1' +
        ',width=' + width +
        ',height=' + height +
        ',top=' + top +
        ',left=' + left;

      window.open(url, 'twitter', opts);

      return false;

    });

    $(document).on('click', '.linkedin-share-js', function (event) {
      event.preventDefault();
      var url = $(this).attr('href'),
        width = 575,
        height = 400,
        left = ($(window).width() - width) / 2,
        top = ($(window).height() - height) / 2,
        opts = 'status=1' +
        ',width=' + width +
        ',height=' + height +
        ',top=' + top +
        ',left=' + left;

      window.open(url, 'linkedin', opts);

      return false;

    });
  }

  wiSocialShares();
  /* Social shares end */

  /* Editor lightbox */
  function wiLightbox() {
    const $image = $('.wi-editor img');

    $image.each(function (key, value) {
      if ($(this).parents('a').length) return;
      if ($(this).parents('.wi-gallery').length) return;
      if ($(this).parents('.wi-carousel-block').length) return;
      if ($(this).parents('.wi-slideshow').length) return;
      if ($(this).parents('.wi-map-block').length) return;
      if ($(this).parents('.wi-quote-block').length) return;

      const src = $(this).attr('src');
      const caption = $(this).parents('.blocks-gallery-item').length ?
        $(this).parents('.blocks-gallery-item').find('figcaption').text() :
        $(this).parents('.wp-block-image').length ?
        $(this).parents('.wp-block-image').find('figcaption').text() :
        '';

      $(this).wrap(`<a href='${src}' data-caption='${caption}' class='lightbox-js'></a>`);
    });
  }

  wiLightbox();
  /* Editor lightbox end */

  /* Slider */
  function wiSliderNavPosition() {
    const $slider = $('.uk-slider, .uk-slideshow');

    $slider.each(function () {
      const $imageHeight = $(this).find('ul li:first-child .wi-card-img-box').height();

      $(this).find('.wi-slider-arrow').css('top', $imageHeight / 2);

      setTimeout(() => {
        $(this).find('.wi-slider-arrow').addClass('loaded');
      }, 200);
    });

    if (window.matchMedia('(max-width: 959px)').matches) {
      $('.wi-slider-slide-img').attr('src', $('.wi-slider-slide-img').attr('mobile-src'));
    }
  }

  wiSliderNavPosition();

  function sliderInitMobile() {

    const $ukSlideshow = $('.uk-slideshow');

    $ukSlideshow.each(function () {
      if (window.matchMedia('(min-width: 768px)').matches) {
        if ($(this).attr('data-custom-ratio')) {
          UIkit.slideshow($(this), {
            ratio: $(this).attr('data-custom-ratio'),
          });
        }
      } else {
        if ($(this).attr('data-mobile-ratio')) {
          UIkit.slideshow($(this), {
            ratio: $(this).attr('data-mobile-ratio'),
          });
        }
      }
    });
  }

  sliderInitMobile();

  setTimeout(() => {
    wiSliderNavPosition();
  }, 1000);

  $(window).on('resize', function () {
    wiSliderNavPosition();
    sliderInitMobile();
  });
  /* Slider end */

  /* Classic editor */
  function wiClasicEditor() {
    const $iframe = $('.content-classic iframe');

    $iframe.each(function () {
      $(this).attr('uk-responsive', true);
    });
  }

  wiClasicEditor();
  /* Classic editor end */

  /* Cookie handling */
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie(cname) {
    let exists = getCookie(cname);

    return (exists != "")
  }
  /* Cookie handling end */

  /* Gallery */
  function wiGallery() {
    if ($('.splide').length === 0) return;

    const splide = new Splide('.splide', {
      type: 'loop',
      perPage: 3,
      focus: 'center',
      autoWidth: true,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: false,
      arrows: true,
      throttle: 300,
      rewindSpeed: 1000,
      perPage: 1,
      start: 0,
      breakpoints: {
        959: {
          start: 1,
        }
      },
    });

    splide.mount();

    $('#gallerySliderPrev').on('click', function (e) {
      e.preventDefault();

      splide.go('<');
    });

    $('#gallerySliderNext').on('click', function (e) {
      e.preventDefault();

      splide.go('>');
    });
  }

  wiGallery();
  /* Gallery end */

  /* Commons */
  function wiCommons() {
    $('.wi-editor iframe').each(function () {
      if ($(this).parents('.wp-block-embed').length > 0) return;

      $(this).attr('uk-responsive', '');
    });

    $('.wi-editor .wp-block-file').each(function () {
      $(this).wrap('<div class="wp-block-file-wrapper"></div>');
    });

    $('.wi-editor .wp-block-cover').each(function () {
      if ($(this).find('.wp-block-cover__image-background').length > 0) {
        $(this).wrap('<div class="wp-block-cover-wrapper image"></div>');
        $(this).addClass('image');
      } else {
        $(this).wrap('<div class="wp-block-cover-wrapper"></div>');
      }
    });

    $('.wi-slideshow-play-js').on('click', function () {
      $(this).siblings('video')[0].play();
      $(this).fadeOut();
    });

    $('.wi-header-search-btn-js').on('click', function (e) {
      e.preventDefault();

      if ($(this).parents('.wi-header-search-box').find('input').val().length > 0 && $('.wi-header-search-input-js').hasClass('active')) {
        $(this).parents('.wi-header-search-box').find('form').submit();
      }

      if (window.matchMedia('(min-width: 960px)').matches) {
        $('.wi-header-search-input-js').toggleClass('active');
      }
    });

    var directionsSlider = new Swiper(".mySwiper", {
      effect: "cards",
      grabCursor: true,
      longSwipes: false,
      loop: false,
      centeredSlides: true,
      slidesPerGroup: 1,
      slidesPerView: 1,
      initialSlide: 0,
      navigation: {
        nextEl: "#directionSliderNext",
        prevEl: "#directionSliderPrev",
      },
    });

    $('#toggleLetterFilter').on('click', function () {
      $(this).toggleClass('active');
      $('#letterFilter').toggleClass('active');
    });

    $('.wi-editor > ul').each(function () {
      $(this).addClass('uk-list uk-list-bullet uk-list-secondary');
    });

    $('.wi-editor > ol').each(function () {
      $(this).addClass('uk-list uk-list-decimal');
    });

    $('.wi-editor ul > p, .wi-editor ol > p').each(function () {
      $(this).remove()
    });
  }

  wiCommons();
  /* Commons end */

  /* Off-canvas menu */
  function offCanvas() {
    const $wiOffcanvasMenu = $('#wiOffcanvasMenu');

    $wiOffcanvasMenu.find('li.has-child a').click(function (e) {
      e.preventDefault();

      $(this).siblings('ul').slideToggle('fast');
      $(this).find('.uk-icon').toggleClass('active');
    });
  }

  offCanvas();
  /* Off-canvas menu end */

  /* Popup 1 */
  function popup1() {
    return;
    $('.wi-card-4-js a').on('click', function (e) {
      e.preventDefault();

      $(this).parents('.wi-card-4-js').addClass('active');
    });
  }

  popup1();
  /* Popup 1 end */

  /* Custom select */
  function wiSelect() {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "wi-select":*/
    x = document.getElementsByClassName("wi-select");
    l = x.length;
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;
      /*for each element, create a new DIV that will act as the selected item:*/
      a = document.createElement("DIV");
      a.setAttribute("class", "wi-select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

      const defaultSelected = `
        <span class="wi-select-default-opt uk-text-truncate">${$(a).text()}</span>
      `;

      a.innerHTML = defaultSelected;

      x[i].appendChild(a);
      /*for each element, create a new DIV that will contain the option list:*/
      b = document.createElement("DIV");
      b.setAttribute("class", "wi-select-items wi-select-hide");
      for (j = 1; j < ll; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
          /*when an item is clicked, update the original select box,
          and the selected item:*/
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = `<span class="uk-text-truncate">${this.innerHTML}</span>`;
              y = this.parentNode.getElementsByClassName("wi-select-same-as-selected");

              if(this.innerHTML.length > 0) {
                $(this).parents('.wi-select').find('.wi-select-clear-js').show();
              } else {
                $(this).parents('.wi-select').find('.wi-select-clear-js').hide();
              }

              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }

              this.setAttribute("class", "wi-select-same-as-selected");

              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);

      a.addEventListener("click", function (e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);

        this.nextSibling.classList.toggle("wi-select-hide");
        this.classList.toggle("wi-select-arrow-active");

        $(this).parents('.wi-select').toggleClass("active");

      });
    }

    function closeAllSelect(elmnt) {
      /*a function that will close all select boxes in the document,
      except the current select box:*/
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("wi-select-items");
      y = document.getElementsByClassName("wi-select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("wi-select-arrow-active");
          y[i].parentElement.classList.remove("active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("wi-select-hide");
        }
      }
    }
    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", (e) => {
      if($(e.target).hasClass('wi-select-search-field-js')) return;

      closeAllSelect();
    });
  }

  function wiSelectExtend() {
    $('.wi-select').prepend(`
      <div class="wi-select-search-box">
        <input type="search" class="wi-select-search-field-js" placeholder="${config.search_text}" />
      </div>
    `);

    $('.wi-select').append(`
      <span class="wi-select-clear wi-select-clear-js">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="20" fill="#88CFC1"/>
        <path d="M24.8145 15.1853L15.1848 24.815" stroke="white" stroke-linecap="round"/>
        <path d="M24.8145 24.8149L15.1848 15.1853" stroke="white" stroke-linecap="round"/>
        </svg>
      </span>
    `);

    const $wiSelectSearchField = $('.wi-select-search-field-js');
    const $wiSelectClearJs = $('.wi-select-clear-js');

    $wiSelectSearchField.on('keyup search', function () {
      const val = $(this).val();

      $(this).parents('.wi-select').find('.wi-select-items div').each(function () {
        if ((val && $(this).text().includes(val)) || !val) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });

    $wiSelectClearJs.on('click', function () {
      $(this).hide();
      const emptyText = $(this).parents('.wi-select').find('select option:first-child').text();
      $(this).parents('.wi-select').find('select').val('0').change();
      $(this).parents('.wi-select.wi-map-select').find('select').val('all').change();

      $(this).parents('.wi-select').find('.wi-select-same-as-selected').removeClass('wi-select-same-as-selected');
      $(this).parents('.wi-select').find('.wi-select-selected').html(`<span class="wi-select-default-opt uk-text-truncate">${emptyText}</span>`);
    });

    $('.wi-select select').each(function() {
      if($(this).val() != '0' && $(this).val() != 'all') {
        $(this).parents('.wi-select').find('.wi-select-clear-js').show();
      }
    });
  }

  if($('.wi-select').length > 0) {
    wiSelect();
    wiSelectExtend();
  }
  /* Custom select end */

  /* MAP */
  function mapListItemSlide() {
    $('.wi-map-list-item-link').on('click', function (e) {
      e.preventDefault();

      $(this).toggleClass('active');
      $(this).next('.wi-map-list-item-sub').slideToggle();
    });
  }

  mapListItemSlide();

  function initMap() {
    const center = new google.maps.LatLng(42.1070666, 43.0053908);

    let zoom = 6.5;

    if ($(window).width() > 1600) {
      zoom = 7.5;
    } else if ($(window).width() > 1366) {
      zoom = 7.2;
    }

    window.newMarkers = [];

    const map = new google.maps.Map(document.getElementById('regionsMap'), {
      center: center,
      zoom: zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      backgroundColor: '#fff',
      disableDefaultUI: true,
      scaleControl: false,
      // scrollwheel: false,
      styles: [{
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "landscape",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "road",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "administrative",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "poi",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "administrative",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          { "visibility": "off" }
        ]
      }, {
        "elementType": "labels",
        "stylers": [{
          "visibility": "off"
        }]
      }, {}]
    });

    const infowindow = new google.maps.InfoWindow();

    const myMarkers = JSON.parse(window.clinic_markers);

    for (let i = 0; i < myMarkers.length; i++) {
      addMarker(myMarkers[i]);
    }

    google.maps.event.addListener(infowindow, 'closeclick', function () {
      clearActiveMarkers();
    });

    const georssLayer = new google.maps.KmlLayer({
      url: 'https://w3i.app/cdn/simplified_regioni_n.kml?=64',
      suppressInfoWindows: true,
      preserveViewport: true,
    });

    georssLayer.setMap(map);

    initZoomControl(map);
    initFullscreenControl(map);

    function addMarker(marker) {
      // console.log(marker);
      // return;
      let id = marker.ID;
      let content = `
         <div class="wi-map-infowindow">
           <h3>${marker.title}</h3>
           <p>${marker.address}</p>
           ${marker.image ? `<img src="${marker.image}" />` : ''}
           <p>${marker.service ? marker.service.names : ''}</p>
           <div class="uk-text-right">
             <a href="${marker.url}" class="uk-button uk-button-primary uk-button-small">${config.see_more_text}</a>
           </div>
         </div>
       `;

      let markerObj = new google.maps.Marker({
        id: id,
        position: new google.maps.LatLng(marker.address_map.lat, marker.address_map.lng),
        map: map,
        icon: config.resources_url + 'images/marker.svg'
      });

      // Marker click listener
      google.maps.event.addListener(markerObj, 'click', (function (marker, content) {
        return function () {

          clearActiveMarkers();

          infowindow.setContent(content);
          infowindow.open(map, marker);

          marker.setIcon(config.resources_url + 'images/marker-active.svg');

          map.setCenter(markerObj.getPosition());
          map.setZoom(zoom + 0.5);
        }
      })(markerObj, content));

      window.newMarkers.push(markerObj);

    }

    $('.wi-map-list-sub-item-js').on('click', function (e) {
      e.preventDefault();

      const key = $(this).attr('data-index');

      openMarker(key);
    });

    $('.wi-map-select .wi-select-items div').on('click', function () {
      const key = $(this).index();

      openMarker(key);
    });

    function clearActiveMarkers() {
      map.setZoom(zoom);
      map.setCenter(center);

      for (let i = 0; i < myMarkers.length; i++) {
        window.newMarkers[i].setIcon(config.resources_url + 'images/marker.svg');
      }
    }
  }

  function initZoomControl(map) {
    document.querySelector(".zoom-control-in").onclick = function () {
      map.setZoom(map.getZoom() + 1);
    };

    document.querySelector(".zoom-control-out").onclick = function () {
      map.setZoom(map.getZoom() - 1);
    };
  }

  function initFullscreenControl(map) {
    const elementToSendFullscreen = map.getDiv().firstChild;
    const fullscreenControl = document.querySelector(".fullscreen-control");
    const mapCustomButtons = document.querySelector(".wi-map-buttons");

    map.controls[google.maps.ControlPosition.RIGHT_TOP].push(mapCustomButtons);

    setTimeout(() => {
      $('.wi-map-buttons-js').fadeIn();
    }, 1000);

    fullscreenControl.onclick = function () {
      if (isFullscreen(elementToSendFullscreen)) {
        exitFullscreen();
      } else {
        requestFullscreen(elementToSendFullscreen);
      }
    };
  }

  function isFullscreen(element) {
    return (
      (document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement) == element
    );
  }

  function requestFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullScreen) {
      element.msRequestFullScreen();
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

  function openMarker(key) {
    google.maps.event.trigger(window.newMarkers[key], 'click');

    $('.wi-map-buttons-location-js').text($(this).parents('.wi-map-list-item').find('.wi-map-list-item-link span:last-child').text());

    clearActiveMarkers();

    window.newMarkers[key].setIcon(config.resources_url + 'images/marker-active.svg');
  }

  $(window).on('load', function () {
    if ($('.wi-map-block').length > 0) {
      initMap();
    }
  });
  /* MAP end */

  /* Player */
  function player() {
    const controls = [
      'play',
      'progress',
      'duration',
      'mute',
      'volume',
      'fullscreen',
    ];

    $('.wp-block-video').each(function () {
      new Plyr($(this).find('video'), {
        controls,
      });
    });

    $('.wp-block-audio').each(function () {
      new Plyr($(this).find('audio'));
      $(this).attr('controlsList', 'nodownload');
    });

  }

  player()
  /* Player end */

  /* slider buttons display only after the slider images are fully loaded */
  function initializeSliderButtons() {
    const sliderImages = document.querySelectorAll('.wi-slider-slide-img');
    const sliderButtons = document.querySelectorAll('.wi-slider-buttons');
    let imagesLoaded = 0;

    sliderImages.forEach(image => {
        image.addEventListener('load', () => {
            imagesLoaded++;
            if (imagesLoaded === sliderImages.length) {
                sliderButtons.forEach(buttonGroup => {
                    buttonGroup.style.display = 'block';
                });
            }
        });

        if (image.complete) {
            image.dispatchEvent(new Event('load'));
        }
    });
  }

  initializeSliderButtons();

});
